import { Pipe, PipeTransform } from '@angular/core';
import {
  mapAiChatApprovalSummary,
  type ApprovalSummary,
} from './ai-chat-utils';

/** Pure pipe so mapping only re-runs when input/toolName/locale change. */
@Pipe({
  name: 'aiChatApprovalSummary',
  pure: true,
})
export class AiChatApprovalSummaryPipe implements PipeTransform {
  transform(
    input: unknown,
    toolName: string,
    locale: string,
  ): ApprovalSummary {
    return mapAiChatApprovalSummary(input, toolName, locale);
  }
}
